import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  withStyles,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
  InputLabel,
} from "@material-ui/core";
import { deactivateKey, getAccessKeys } from "../../actions/index";
import AccessKeyGenerator from "./AccessKeyGenerator";

const styles = theme => ({
  loader: {
    color: "#1e5abb",
  },
  deactivateButton: {
    backgroundColor: "#B90E0A",
    color: "white",
    "&:hover": {
      background: "#990F02",
    },
  },
});

const AccessKeys = ({
  classes,
  accessKeys,
  deactivateAccessKey,
  getAccessKeys,
  deactivateKey,
}) => {
  const [loading, setLoading] = useState(true);
  const [showDeactivated, setShowDeactivated] = useState(false);
  const [keys, setKeys] = useState([]);

  useEffect(() => {
    getAccessKeys();
  }, []);

  useEffect(() => {
    if (accessKeys.data) {
      const keys = showDeactivated
        ? accessKeys.data
        : accessKeys.data.filter(({ active }) => !!active);
      setKeys(keys);
      setLoading(false);
    }
  }, [accessKeys]);

  useEffect(() => {
    setLoading(true);
    getAccessKeys();
  }, [deactivateAccessKey]);

  if (loading) {
    return (
      <Container>
        <Box textAlign="center">
          <CircularProgress className={classes.loader} />
        </Box>
      </Container>
    );
  }

  const toggleShowDeactivated = e => {
    const { data } = accessKeys;
    const { checked } = e.target;
    const displayedKeys = checked
      ? data
      : data.filter(({ active }) => !!active);
    setShowDeactivated(checked);
    setKeys(displayedKeys);
  };

  return (
    <Container>
      <TableContainer component="paper">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <AccessKeyGenerator />
              </TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell>
                <Checkbox
                  checked={showDeactivated}
                  label="Show deactivated"
                  onChange={toggleShowDeactivated}
                  color="success"
                />
                Pokaż nieaktywne
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Klucz API</TableCell>
              <TableCell>Klucz tajny</TableCell>
              <TableCell>Utworzono</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {keys.map(({ code, apiKey, secret, createdAt, active }) => (
              <TableRow key={code}>
                <TableCell>{apiKey}</TableCell>
                <TableCell>{secret}</TableCell>
                <TableCell>{createdAt}</TableCell>
                <TableCell>
                  {active ? (
                    <Button
                      className={classes.deactivateButton}
                      onClick={() => deactivateKey(code)}
                    >
                      Deaktywuj
                    </Button>
                  ) : (
                    <InputLabel error variant="standard">
                      Deaktywowany
                    </InputLabel>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

const mapDispatchToProps = {
  deactivateKey,
  getAccessKeys,
};

const mapStateToProps = ({ accessKeys, deactivateAccessKey }) => ({
  accessKeys,
  deactivateAccessKey,
});

export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(AccessKeys)
);
